// extracted by mini-css-extract-plugin
export var pillWrapper = "_yb-0";
export var showOverflow = "_yb-1";